import { useTranslation } from "react-i18next";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import NavigationDrawer from "../../components/drawer/NavigationDrawer";
import {
  NAVIGATION_DRAWER_TYPE_WAREHOUSES,
} from "../../components/drawer/NavigationDrawer/NavigationDrawer";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import useCheckPermission from "../../hooks/usePermission";
import CreateItemDialog from "../../components/dialog/CreateItemDialog";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG, MATERIAL_REGISTRY_TABLE_NAME } from "./PageTablesConfig";
import TableService from "../../services/tableService";
import FilterTable from "../../components/table/FilterTable";
import { Grid } from "@mui/material";
import { MANAGE_PARTS_PERMISSION } from "../../helpers/constants";
import useDialogWithId from "../../hooks/useDialogWithId";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import useOfferService from "../../services/offerService";
import useLocalData from "../../hooks/useLocalData";
import { useAsync } from "../../hooks/useAsync";
import UniversalToolBarWithDialogs from "../../components/bar/UniversalToolBarWithDialogs";
import { partExportXslxUrl } from "../../helpers/apiUrls";

const TABLE_CONFIGS = [
    { name: MATERIAL_REGISTRY_TABLE_NAME, config: MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG },
];

export default function MaterialRegistryPage(props) {
  const { pageName } = props;

  const { t } = useTranslation(); 

    const [isCopyMode, setCopyMode] = useState(false)

    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [hasEditPermission] = useCheckPermission(MANAGE_PARTS_PERMISSION);

  
       const [
        openItemDialog,
        selectedPartId,
        onOpenItemDialog,
        onCloseItemDialog,
    ] = useDialogWithId();


    const {
        page: materialPage,
        pageSize: materialPageSize,
        handleChangePageWithSearchParams: handleChangeMaterialPage,
        handleChangePageSizeWithSearchParams: handleChangeMaterialPageSize,
        resetPageNumber,
        searchParams,
        setSearchParams,
        onClearSearchParams
    } = usePaginationWithSearchParams(undefined, {'page_size' : 100}, 100);

 
    useEffect(() => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('page_size', materialPageSize || 100);
        setSearchParams(newSearchParams)
    }, [searchParams, props.itemType]);


const {
    getPartListData,
    getPartFilteringData
} = useOfferService();


    const {
        data,
        dataCount: countRecords,
        dataRefetch
    } = useLocalData(getPartListData, searchParams, true)

    const filteringData = useAsync(getPartFilteringData)

    const onClickEdit = useCallback((e, itemId) => {
        e.stopPropagation();
        onOpenItemDialog(itemId)
    }, [])

    
    const onClickCopy = useCallback((e, itemId) => {
        e.stopPropagation();
        setCopyMode(true)
        onOpenItemDialog(itemId)

    }, [])

    const itemsData = React.useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG,
                data ? data : [],
                hiddenColumnsForTables ? hiddenColumnsForTables[MATERIAL_REGISTRY_TABLE_NAME] : [],
                columnsOrdersForTables ? columnsOrdersForTables[MATERIAL_REGISTRY_TABLE_NAME] : [],
                onClickEdit,
                onClickCopy,
                hasEditPermission
            ),
        [MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG,
            data,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickEdit,
            onClickCopy,
            hasEditPermission]
    );

    const itemsExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG,
            hiddenColumnsForTables ? hiddenColumnsForTables[MATERIAL_REGISTRY_TABLE_NAME] : [],
            columnsOrdersForTables ? columnsOrdersForTables[MATERIAL_REGISTRY_TABLE_NAME] : []
        );
    }, [
        MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG,
        hiddenColumnsForTables,
        columnsOrdersForTables
    ]);


    const handleCloseItemDialog = useCallback(() =>{
        onCloseItemDialog()
        setCopyMode(false)
        dataRefetch()
    },[])
   

    const isLoading = data === undefined || filteringData.loading



  return (
    <NavigationDrawer
      pageName={pageName}
      drawerType={NAVIGATION_DRAWER_TYPE_WAREHOUSES}
    >
      <DefaultPageWrapper titleKey={"material_registry"}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          columnSpacing={2}
          rowSpacing={2}
          style={{

            overflowX: "hidden"
          }}
        >
          <Grid item xs={12} marginY={1}>
            <UniversalToolBarWithDialogs
              pageName={pageName}
              tableConfig={TABLE_CONFIGS}
              filteringData={filteringData ? filteringData : []}
              refreshTable={dataRefetch}
              resetPageNumber={resetPageNumber}
              hiddenColumnsForTables={hiddenColumnsForTables}
              setHiddenColumnsForTables={setHiddenColumnsForTables}
              columnsOrdersForTables={columnsOrdersForTables}
              setColumnsOrdersForTables={setColumnsOrdersForTables}
              showMassActionButton={false}
              showOpenCloseFilterButton={false}
              showCleanfiltersButton={true}
              showMyFiltersButton={true}
              showSearchButton={true}
              onClickCreateItem={(e) => onOpenItemDialog()}
              itemType={"part"}
              cleanFiltersFn={onClearSearchParams}
              showCreateButton={true}
              mdGridButton={2.75}

            />
          </Grid>
          <LoaderWrapper showLoader={isLoading}>
            <Grid item xs={12}>
              <FilterTable
                data={itemsData}
                onClickRow={() => undefined}
                countRecords={countRecords}
                resetPageNumber={resetPageNumber}
                page={materialPage}
                onPageChange={handleChangeMaterialPage}
                rowsPerPage={materialPageSize}
                onRowsPerPageChange={handleChangeMaterialPageSize}
                style={{ maxHeight: "70vh" }}
                showCleanFilterIcon={true}
                showContextMenu={false}
                showExportToFileButton={true}
                exportToFileUrl={partExportXslxUrl}
                exportToFileSearchParams={searchParams}
                exportToFileHeaders={itemsExportHeaders}
                exportToFileFileName={`${t("tabs.material_registry_tab.materials").replace(" ", "_")}.xlsx`}
                headersConfig={TableService.getHeadersConfigForCollapsibleTable(
                  MATERIAL_REGISTRY_TABLE_FIELDS_CONFIG,
                  filteringData ? filteringData : [],
                  hiddenColumnsForTables ? hiddenColumnsForTables[MATERIAL_REGISTRY_TABLE_NAME] : [],
                  columnsOrdersForTables ? columnsOrdersForTables[MATERIAL_REGISTRY_TABLE_NAME] : []
                )}
                showDetailsIcon={false}
                showCounterRecords={false}
                showCheckbox={false}
              />
            </Grid>
          </LoaderWrapper>

          {openItemDialog && (
            <CreateItemDialog
              open={openItemDialog}
              onClose={handleCloseItemDialog}
              itemType={"part"}
              itemId={selectedPartId}
              readOnly={!hasEditPermission}
              isCopyObject={isCopyMode}
              onRefetchData = {dataRefetch}
            />
          )}
        </Grid>
      </DefaultPageWrapper>
    </NavigationDrawer>
  );
}
MaterialRegistryPage.propTypes = {

};

MaterialRegistryPage.defaultProps = {};
